import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import UserService from "./services/UserService"
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const renderApp = () => root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
UserService.initKeycloak(renderApp);

